<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="College Development Committee"
                   :links="[{title:'Home', url:'/'},{title:'College Development Committee'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="2"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1 text-center mb-4">College Development Committee</div>
          <div>
            <DataTable :value="Members" :rowHover="true">
              <Column field="no" header="#"></Column>
              <Column field="name" header="Name of Staff"></Column>
              <Column field="post" header="Post"></Column>
              <Column field="department" header="Department"></Column>
            </DataTable>
          </div>
        </section>
      </div>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/about/governance/Sidebar.vue";
import Programmes from "@/views/about/Programmes";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default {
  name: "CollegeDevCom",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    Programmes, DataTable, Column,
  },
  data() {
    return {
      Members: [
        {
          no: 1,
          name: 'Dr.Patil P.M.',
          post: 'Chairman',
          department: 'Principal'
        },
        {
          no: 2,
          name: 'Prof. Rokade P. P.',
          post: 'Member',
          department: 'IT'
        },
        {
          no: 3,
          name: 'Prof.Chandgude A.S.',
          post: 'Member',
          department: 'Computer'
        },
        {
          no: 4,
          name: 'Prof. Karale S. A.',
          post: 'Member',
          department: 'Civil'
        },
        {
          no: 5,
          name: 'Dr.Tapare P.C.',
          post: 'Member',
          department: 'Electrical'
        },
        {
          no: 6,
          name: 'Dr. Ubale U. V',
          post: 'Member',
          department: 'MBA'
        },
        {
          no: 7,
          name: 'Prof. Gujarathi T. V.',
          post: 'Member',
          department: 'Mechanical'
        },
        {
          no: 8,
          name: 'Prof. khirsagar D. P',
          post: 'Member',
          department: 'Office'
        }
      ],
    }
  }
}
</script>
<style lang="scss" scoped>

::v-deep(.p-datatable) {
  .p-datatable-header {
    background: #e6e6e6;
    color: #404040;
  }

  .p-datatable-thead > tr > th {
    background: #e6e6e6;
    color: #404040;
  }
}
</style>